import Rails from '@rails/ujs';

export default class MoeCompleteAction {
  constructor() {
    this.completeState = {
      actionId: null,
      submitUrl: null
    };
    this.bindEvents();
  }

  bindEvents() {
    $(document).on('click', '.moe-complete-btn', (e) => this.openCompleteModal($(e.currentTarget)));
    $('#moeCompleteConfirm').on('click', () => this.submitCompletion());
  }

  openCompleteModal(btn) {
    this.completeState.actionId = btn.data('action-id');
    this.completeState.submitUrl = btn.data('complete-url');
    $('#moeCompleteError').addClass('d-none');

    const now = new Date();
    const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    $('#moeCompleteEndedAt').val(local);
    $('#moeCompleteActionModal').modal('show');
  }

  submitCompletion() {
    $('#moeCompleteConfirm').prop('disabled', true);
    const data = new URLSearchParams({
      action_execution_id: this.completeState.actionId,
      ended_at: $('#moeCompleteEndedAt').val() || '',
      authenticity_token: $('meta[name="csrf-token"]').attr('content')
    }).toString();
    Rails.ajax({
      url: this.completeState.submitUrl,
      type: 'PUT',
      data,
      success: (resp) => {
        if (resp.success) {
          $('#moeCompleteActionModal').modal('hide');
          location.reload();
        } else {
          $('#moeCompleteError').text(resp.error).removeClass('d-none');
          $('#moeCompleteConfirm').prop('disabled', false);
        }
      },
      error: (xhr) => {
        const msg = xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Erreur serveur';
        $('#moeCompleteError').text(msg).removeClass('d-none');
        $('#moeCompleteConfirm').prop('disabled', false);
      }
    });
  }

  onDestroy() {
    $(document).off('click', '.moe-complete-btn');
    $('#moeCompleteConfirm').off('click');
  }
}
